import { usuarioStorage } from "@/store/usuario/UsuarioStorage";
import { NavigationGuardNext, Route } from "vue-router";
import Vue from "vue";
import { Authoritie } from "@/models/administracao/usuario/GrupoModel";

export class RouteGuard {

    public static acessoSaude(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
        usuarioStorage.authorities.includes(Authoritie.ANALISTA_SAUDE)
            ? next()
            : next({ name: 'HomePage' });
    }

    public static acessoAssistencia(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
        usuarioStorage.authorities.includes(Authoritie.ANALISTA_ASSISTENCIA_24H)
            ? next()
            : next({ name: 'HomePage' });
    }

    public static acessoContabil(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
        usuarioStorage.authorities.includes(Authoritie.INTEGRACAO_CONTABIL)
            ? next()
            : next({ name: 'HomePage' });
    }

    public static acessoOrcamento(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
        usuarioStorage.authorities.includes(Authoritie.PERITO_ORCAMENTO_AUTO_ONLINE)
            ? next()
            : next({ name: 'HomePage' });
    }

    public static acessoAdministrativo(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
        usuarioStorage.authorities.includes(Authoritie.ADMINISTRADOR)
            ? next()
            : next({ name: 'HomePage' });
    }
}
